import {
  useTargetBreakdownChildren,
  useTargetBreakdownsByTargetIds,
} from '../../../../../../../services/modules/target/target.queries';
import { TARGET_FIRST_LEVEL_DEPTH } from '../../../../../../target/target.constants';
import { UseOrderTargetsBreakdownsParams } from '../orderObjectTargetsTab.types';
import {
  getBreakdownChildrenRequests,
  getRequestedBreakdownQueries,
  mergeOrderTargetBreakdowns,
} from '../orderObjectTargetsTab.utils';

const useOrderTargetsBreakdowns = ({
  targetIds,
  expandedIds,
  itemTargetIds,
  isUsingFullTrees,
}: UseOrderTargetsBreakdownsParams) => {
  const firstLevels = useTargetBreakdownsByTargetIds({
    targetIds,
    depth: TARGET_FIRST_LEVEL_DEPTH,
  });
  const treeTargetIds = new Set(isUsingFullTrees ? targetIds : []);
  const trees = useTargetBreakdownsByTargetIds({ targetIds, enabledIds: treeTargetIds });
  const children = useTargetBreakdownChildren(
    getBreakdownChildrenRequests({ expandedIds, itemTargetIds, treeTargetIds }),
  );

  const queries = getRequestedBreakdownQueries({ firstLevels, trees, children, treeTargetIds });

  return {
    breakdowns: mergeOrderTargetBreakdowns({ firstLevels, trees, children, treeTargetIds }),
    hasError: queries.some((query) => query.isError && !query.items),
    refetch: () => queries.filter((query) => query.isError).forEach((query) => query.refetch()),
  };
};

export default useOrderTargetsBreakdowns;
